import { useState } from 'react'
import { generateRandomString } from 'shared/helpers/StringHelper'

const usePersistantRandomString = () => {
  const [randomString] = useState(generateRandomString())
  return randomString
}

export default usePersistantRandomString
